import cloud from "./cloud.js";

export default {
	callback: 0,
	calls: [],
	listening: false,

	get $log() {
		return window.vm.$log;
	},

	async appVersion() {
		return this.send("appVersion");
	},

	async barcode() {
		this.$log(`Bridge: Start barcode read`);

		return this.send("barcode");
	},

	async findController(serial, system) {
		this.$log(`Bridge: Find controller ${serial}`);

		// get last reported ip from cloud
		let last = await cloud.getLastKnown(system);

		// get controller credentials from keychain
		let credentials = await cloud.getCredentials(system);

		let discovered = await this.send("findController", {
			serial,
			system,
			last,
			credentials,
		});

		return discovered;
	},

	async biometricIsAvailable() {
		return this.send("biometric.isAvailable");
	},

	async biometricStore(username, password) {
		this.$log(`Bridge: Biometric store ${username}`);

		return this.send("biometric.store", {
			username,
			password,
		});
	},

	async biometricLogin() {
		this.$log(`Bridge: Login`);

		return this.send("biometric.login");
	},

	reprovisionController(ip, mac) {
		this.$log(`Bridge: Reprovision controller ${ip} ${mac}`);

		return this.send("reprovision", {
			ip,
			mac,
		});
	},


	// Locks

	async lockInit(accessKey, secret, allyName, allyToken) {
		this.$log(`Bridge: Lock init`);

		return this.send("lock.init", { accessKey, secret, allyName, allyToken });

	},

	async lockSearch(timeout) {
		this.$log(`Bridge: Lock search, timeout: ${timeout}`);

		return this.send("lock.search", { timeout });

	},

	async lockConnect(deviceId, timeout, key) {
		this.$log(`Bridge: Lock connect ${deviceId}, timeout: ${timeout}`);

		return this.send("lock.connect", { deviceId, timeout, key });

	},

	async lockPair(deviceId, timeout, pinCode) {
		this.$log(`Bridge: Lock pair ${deviceId}, timeout: ${timeout}`);

		return this.send("lock.pair", { deviceId, timeout, pinCode });

	},

	async lockUnpair(deviceId) {
		this.$log(`Bridge: Lock unpair ${deviceId}`);

		return this.send("lock.unpair", { deviceId });

	},

	async lockLock(deviceId, key) {
		this.$log(`Bridge: Lock lock ${deviceId}`);

		return this.send("lock.lock", { deviceId, key });

	},

	async lockUnlock(deviceId, key) {
		this.$log(`Bridge: Lock unlock ${deviceId}`);

		return this.send("lock.unlock", { deviceId, key });

	},

	onMessage(event) {
		let message;
		try {
			message = JSON.parse(event.data);
		} catch (e) {
			// not all messages are our json
			return;
		}

		switch (message.type) {
			case "bridge.reply":
				this.reply(message);
				break;
		}
	},

	reply(message) {
		let promise = this.calls[message.callback];
		if (promise) {
			if (message.error) {
				promise.reject(message.error);
			} else {
				promise.resolve(message.data);
			}
		}
	},

	send(type, data) {
		if (!this.listening) {
			this.listening = true;

			const target =
				navigator.appVersion.indexOf("Android") > -1 ? document : window;
			target.addEventListener("message", event => {
				this.onMessage(event);
			});
		}

		return new Promise((resolve, reject) => {
			let cb = this.callback++;

			this.calls[cb] = {
				resolve: resolve,
				reject: reject,
			};

			let json = JSON.stringify({
				type: type,
				callback: cb,
				data: data,
			});

			// eslint-disable-next-line no-undef
			ReactNativeWebView.postMessage(json);
		});
	},
};
